export function mountVideoPlayer(root = document) {
	const players = root.querySelectorAll(".solufy-video-player[data-video-id]");
	players.forEach((player) => {
		const videoId = player.getAttribute("data-video-id");
		if (!videoId) return;

		const trigger = player.querySelector(".solufy-video-trigger");
		const iframeSlot = player.querySelector(".solufy-video-iframe-slot");

		if (!trigger || !iframeSlot) return;

		const play = () => {
			if (player.classList.contains("is-playing")) return;
			player.classList.add("is-playing");
			const iframe = document.createElement("iframe");
			iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0&modestbranding=1`;
			iframe.title = player.getAttribute("data-video-title") || "Solufy Product Video";
			iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
			iframe.allowFullscreen = true;
			iframeSlot.innerHTML = "";
			iframeSlot.appendChild(iframe);
		};

		trigger.addEventListener("click", play);
	});

	return () => {
		// cleanup if needed
	};
}
